// @ts-nocheck
import { ICommentModel } from '../models/CommentModel';

export enum CommentsActions {
  GET_COMMENTS = 'GET_COMMENTS',
  GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS',
  GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR',

  ADD_COMMENT = 'ADD_COMMENT',
  ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS',
  ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR',

  EDIT_COMMENT = 'EDIT_COMMENT',
  EDIT_COMMENT_SUCCESS = 'EDIT_COMMENT_SUCCESS',
  EDIT_COMMENT_ERROR = 'EDIT_COMMENT_ERROR',

  DELETE_COMMENTS = 'DELETE_COMMENTS',
  DELETE_COMMENTS_SUCCESS = 'DELETE_COMMENTS_SUCCESS',
  DELETE_COMMENTS_ERROR = 'DELETE_COMMENTS_ERROR',
}

export interface CommentsState {
  comments: Array<ICommentModel>;
  loading: boolean;
  error: string | null;
}

interface GetCommentsAction {
  type: CommentsActions.GET_COMMENTS;
  payload?: any;
}

interface GetCommentsSuccessAction {
  type: CommentsActions.GET_COMMENTS_SUCCESS;
  payload: Array<ICommentModel>;
}

interface FetchCommentsErrorAction {
  type: CommentsActions.GET_COMMENTS_ERROR;
  payload: string;
}

interface AddCommentsAction {
  type: CommentsActions.ADD_COMMENT;
  payload?: any;
}

interface AddCommentsSuccessAction {
  type: CommentsActions.ADD_COMMENT_SUCCESS;
  payload: any;
}

interface AddCommentsErrorAction {
  type: CommentsActions.ADD_COMMENT_ERROR;
  payload: string;
}

interface EditCommentsAction {
  type: CommentsActions.EDIT_COMMENT;
  payload?: any;
}

interface EditCommentsSuccessAction {
  type: CommentsActions.EDIT_COMMENT_SUCCESS;
  payload: any;
}

interface EditCommentsErrorAction {
  type: CommentsActions.EDIT_COMMENT_ERROR;
  payload: string;
}

interface DeleteCommentsAction {
  type: CommentsActions.DELETE_COMMENTS;
  payload?: any;
}

interface DeleteCommentsSuccessAction {
  type: CommentsActions.DELETE_COMMENTS_SUCCESS;
  payload: any;
}

interface DeleteCommentsErrorAction {
  type: CommentsActions.DELETE_COMMENTS_ERROR;
  payload: string;
}

export type CommentsAction =
  | GetCommentsAction
  | GetCommentsSuccessAction
  | FetchCommentsErrorAction
  | AddCommentsAction
  | AddCommentsSuccessAction
  | AddCommentsErrorAction
  | EditCommentsAction
  | EditCommentsSuccessAction
  | EditCommentsErrorAction
  | DeleteCommentsAction
  | DeleteCommentsSuccessAction
  | DeleteCommentsErrorAction;
